// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SchematicWrapper__wrapper","cardHeader":"SchematicWrapper__cardHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SchematicWrapper/SchematicWrapper.scss
// module id = ./src/components/SchematicWrapper/SchematicWrapper.scss
// module chunks = 2